import React, { FunctionComponent } from 'react'
import { Callback } from '../../utils/types'
import { presets } from './adminProfilePresetsConfig'

interface Props {
  onChange: Callback
  // The badges currently checked -- used to derive which preset (if any)
  // is "active" for the blue-background highlight, so an admin whose
  // existing badges already match a preset shows it highlighted on load,
  // not only after that preset is clicked in this session.
  selectedBadges?: string[]
}

// Set equality, not array equality: checkbox order and preset-list order
// have no meaning, only membership does.
const sameBadges = (a: string[], b: string[]) =>
  a.length === b.length && a.every((badge) => b.includes(badge))

const AdminProfilePresets: FunctionComponent<Props> = ({
  onChange,
  selectedBadges = [],
}) => {
  const activePreset =
    Object.keys(presets).find((name) =>
      sameBadges(presets[name], selectedBadges)
    ) ?? null

  const handlePresetClick = (permissions: string[]) => {
    if (onChange !== null && onChange !== undefined) onChange(permissions)
  }

  return (
    <div>
      <span className="h1"> Presets </span>
      {Object.keys(presets).map((name, i) => {
        const isActive = name === activePreset
        return (
          <button
            key={i}
            data-testid={`preset-button-${name}`}
            type="button"
            aria-pressed={isActive}
            className={`button button-drive-america${
              isActive ? '' : ' button-drive-america--secondary'
            }`}
            style={{ marginRight: '8px' }}
            onClick={() => handlePresetClick(presets[name])}
          >
            {name}
          </button>
        )
      })}
    </div>
  )
}

export default AdminProfilePresets
